import * as types from '../actionType'

const initialState = []

const newPassword = (state = initialState, action) => {
    switch (action.type) {
        case types.RESET_PAS:
            return action.payload
        default:
            return state
    }
}

export {newPassword};